export const STRATEGY_TRANSFER_OPTION = {
    "getTransferOptions": function (json) {
        if (typeof onTransferOptions === 'function') {
            onTransferOptions(json.data);
        }
    },
    "onUnavailableAgent": function (json) {
        if (typeof onUnavailableAgent === 'function') {
            onUnavailableAgent(json.data);
        }
    }
}



// WEBPACK FOOTER //
// ./src/Strategies/strategyTransferOption.js